import { getUrlKey } from '@/core/utils'

const { origin, href, port } = window.location
const env = (() => {
  // eslint-disable-next-line no-underscore-dangle
  const _env = getUrlKey('_env')
  if (_env) {
    return _env
  }

  if (/test/.test(origin)) {
    return 'testing'
  }

  if (/pre/.test(origin)) {
    return 'pre'
  }

  if (port && port !== '80' && port !== '443') {
    return 'testing'
  }

  return 'production'
})()

export const local = env === 'local' // 是否是本地环境
export const test = env === 'testing' // 是否测试环境
export const pre = env === 'pre' // 是否是预发布环境
export const prod = env === 'production' // 是否是正式环境
export const debug = href.indexOf('debug=true') > -1

export default env // 当前环境的标识
